import {chartColors, defaultChartColorIndex} from "../constants/chart-constants";
import i18n from "../i18n";

export default {
    methods: {
        /**
         * Format and beautify given list of plotLines
         * @param {Array} plotLinesArray
         */
        computePlotLines(plotLinesArray) {
            let formattedPlotLines = [];
            let index = defaultChartColorIndex;

            plotLinesArray.forEach(plotObj => {
                // for each plot line object, add alignment, color, width, placement
                const labelTranslation = i18n.t(`sensors-page.${plotObj.text}`);

                formattedPlotLines.push(
                    {
                        label: {
                            text: `${labelTranslation}: ${plotObj.value || ''}`,
                            align: 'left',
                            x: 2,
                            rotation: 0 // always horizontal
                        },
                        width: 2,
                        value: plotObj.value,
                        color: chartColors[index % chartColors.length]
                    }
                );
                index++;
            });

            return formattedPlotLines
        }
    }
};